import React, { useState, useRef } from 'react'
import { Box, Typography, TextField, Button, Card } from '@material-ui/core'
import clsx from 'clsx'
import Markdown from 'react-markdown'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'


const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        width: '100%',
        borderRadius: '16px',
        border: '1px solid ' + theme.palette.primary.dark,
        backgroundColor: theme.palette.colors.fillStroke[400],
        padding: '16px',
    },
    title: {
        padding: '16px',
        textAlign: 'center',
        // color: theme.palette.primary.main,
        margin: 0,
        borderRadius: '8px',
        border: '1px solid ' + theme.palette.primary.dark,
    },
    container: {
        height: '100%',
        width: '100%',
    },
    chatContainer: {
        flex: 1,
        overflowY: 'auto',
        padding: '16px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    messageBubble: {
        maxWidth: '70%',
        padding: '12px 16px',
        borderRadius: '18px',
        wordWrap: 'break-word',
        position: 'relative',
    },
    userBubble: {
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        alignSelf: 'flex-end',
        borderBottomRightRadius: '4px',
    },
    assistantBubble: {
        backgroundColor: 'white',
        color: '#333',
        alignSelf: 'flex-start',
        borderBottomLeftRadius: '4px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
    },
    messageLabel: {
        fontSize: '12px',
        fontWeight: 'bold',
        marginBottom: '4px',
        opacity: 0.8,
    },
    assistantLabel: {
        color: '#000',
    },
    inputContainer: {
        display: 'flex',
        gap: '12px',
        alignItems: 'flex-end',
        padding: '16px 0',
        borderRadius: '8px',
        border: '1px solid ' + theme.palette.primary.dark,
        padding: '16px',
    },
    inputField: {
        flex: 1,
    },
    sendButton: {
        minWidth: '48px',
        height: '48px',
        backgroundColor: theme.palette.primary.main,
    },
    label: {
        fontSize: '14px',
        fontWeight: 'bold',
    },
    inputText: {
        fontSize: '14px',
    },
}));
const Chat = (props) => {
    const classes = useStyles();
    const messagesEndRef = useRef(null);

    return (
        <Box className={classes.root}>
            <Card>
                <Box component={'h2'} className={classes.title}>{props.title}</Box>
            </Card>
            <Card>
                <Box className={classes.container}>
                    {/* Chat Messages Container */}
                    <Box className={classes.chatContainer}>
                        {props.conversation
                            .slice()
                            .sort((a, b) => a.order - b.order)
                            .map((item) => (
                                <Box
                                    key={item.order}
                                    className={`${classes.messageBubble} ${item.role === 'user' ? classes.userBubble : classes.assistantBubble
                                        }`}
                                >
                                    <Typography variant="caption" className={
                                        clsx(classes.messageLabel, item.role === 'assistant' && classes.assistantLabel)}>
                                        {item.role === 'user' ? 'Tú' : 'Asistente TALI'}
                                    </Typography>
                                    {item.role === 'user' ? (
                                        <Typography variant="body1">{item.content}</Typography>
                                    ) : (
                                        <Markdown>{item.content}</Markdown>
                                    )}
                                </Box>
                            ))}
                        {/* Elemento invisible para el autoscroll */}
                        <div ref={messagesEndRef} />
                    </Box>

                    {/* Input Container */}
                    <Box className={classes.inputContainer}>
                        <TextField
                            id="comment"
                            placeholder="Escribe tu mensaje..."
                            fullWidth
                            multiline
                            maxRows={3}
                            className={classes.inputField}
                            value={props.comment || ''}
                            variant="outlined"
                            onChange={(e) => props.setComment(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    props.handleSentMessage();
                                }
                            }}
                        />
                        <Button
                            variant="contained"
                            className={classes.sendButton}
                            onClick={props.handleSentMessage}
                            disabled={!props.comment.trim()}
                        >
                            Enviar
                        </Button>
                    </Box>
                </Box>
            </Card>
        </Box >
    )
}

Chat.propTypes = {
    title: PropTypes.string.isRequired, // titulo de la conversacion
    conversation: PropTypes.array.isRequired, // historial de la conversacion
    setComment: PropTypes.bool.isRequired, // si se setea el comentario
    handleSentMessage: PropTypes.func.isRequired, // handle sent mensaje
}
Chat.defaultProps = {
    title: 'Asistente TALI',
    conversation: [],
    setComment: true,
    handleSentMessage: () => {},
}

export default Chat